module.exports = __webpack_public_path__ + "static/schaukel01-e00474d3daad4cccd405af84eb123e65.jpg";